import {useMutation, useQueryClient} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import Alert from "react-s-alert";
import {
  UpdateSsoConfigurationRequest,
  SsoService,
} from "../../../services/SsoService";
import {buildResponseErrorMessage} from "../../../services/api/errorHelpers";

export const useUpdateSsoConfiguration = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {organizationId} = useParams<{organizationId: string}>();

  return useMutation(
    (data: UpdateSsoConfigurationRequest) =>
      SsoService.updateConfiguration(organizationId, data),
    {
      onSuccess: () => {
        Alert.success("SSO configuration was successfully updated.");
        queryClient.invalidateQueries(["ssoConfiguration"]);
        navigate(
          `/admin/organizations/${organizationId}/sso-configuration`,
        );
      },
      onError: async resp => {
        Alert.error(
          await buildResponseErrorMessage(
            resp,
            "Failed to update SSO configuration.",
          ),
        );
      },
    },
  );
};
